import React, { FC } from 'react';
import { MutationFunction } from 'react-apollo';
import { FormControlLabel, Switch } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import {
  UpdateClientFollowMappingComponent,
  ClientFollowMapping,
  ClientFollowMappingStatus,
} from 'api';
import { useNotify } from 'hooks';

interface IProps extends WithStyles<typeof styles> {
  mapping: ClientFollowMapping;
}

const styles = (theme: Theme) =>
  createStyles({
    active: {
      color: theme.palette.text.primary,
    },
    inactive: {
      color: theme.palette.text.secondary,
    },
  });

const EnableSwitch: FC<IProps> = ({ mapping, classes }) => {
  const { t } = useTranslation();
  const { Active, Disabled } = ClientFollowMappingStatus;
  const checked = mapping.mapping_status === Active;
  const notify = useNotify();

  function handleSetStatus(status: ClientFollowMappingStatus, mutation: MutationFunction) {
    return mutation({
      variables: {
        data: {
          id: mapping.id,
          title: mapping.title,
          mapping_status: status,
          all_users: mapping.all_users,
        },
      },
    });
  }

  function editNotify() {
    const message = t('components:savedSuccessfully');
    notify.info({ message });
  }

  return (
    <UpdateClientFollowMappingComponent onError={notify.mutationError} onCompleted={editNotify}>
      {mutation => (
        <FormControlLabel
          label={t('common:status')}
          labelPlacement="start"
          classes={{ label: checked ? classes.active : classes.inactive }}
          control={
            <Switch
              checked={checked}
              onChange={event => handleSetStatus(checked ? Disabled : Active, mutation)}
              color="primary"
            />
          }
        />
      )}
    </UpdateClientFollowMappingComponent>
  );
};

export default withStyles(styles)(EnableSwitch);
